import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, shareReplay } from 'rxjs';
import { DatasetMetainfo } from '@models/mood/dataset-metainfo';

@Injectable({
  providedIn: 'root',
})
export class DatasetMetainfoService {
  constructor(private _httpClient: HttpClient) { }

  async getExistingDatasetMetainfo(metainfo_id: string): Promise<DatasetMetainfo> {
    let metainfo = this._httpClient.get<DatasetMetainfo>(`api/metainfo/${metainfo_id}`).pipe(
      shareReplay(1)
    );
    return firstValueFrom(metainfo);
  }
}
